<app-floorplan-pipelines-menu></app-floorplan-pipelines-menu>
<hr />
<app-floorplan-cable-route-menu></app-floorplan-cable-route-menu>
<hr />
<app-floorplan-protective-tubes-menu></app-floorplan-protective-tubes-menu>
<hr />
<app-floorplan-wires-menu></app-floorplan-wires-menu>
